<template>
    <div class="punctuality-container">
        <div class="field has-addons">
            <p class="control">
                <input class="input is-small time-input" type="text" :value="time" readonly />
            </p>
            <p v-if="taskType === 'MERCHANT_RETURN' || taskType === 'PICKUP'" class="control">
              <input class="input is-small time-input" type="text" :value="stopTime" readonly />
            </p>
            <p class="control">
                <a class="button is-static is-small">
                    <strong>{{ label }}</strong>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Time',
  props: {
    datetime: String,
    stopDateTime: String,
    taskType: String,
    label: String,
  },
  computed: {
    time() {
      const { datetime } = this.$props
      return moment(datetime).format('HH:mm')
    },
    stopTime() {
      const { stopDateTime } = this.$props
      return moment(stopDateTime).format('HH:mm')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';
.punctuality-container {
    width: 130px;
}

.time-input {
    width: 50px;
}

.deviation {
    margin-right: 7px;
}
</style>
